import React from 'react'
import { ProfileShareModel } from './'
import i18next from 'i18next'

const ProjectProfileShare = ({ shareSystemProps }) => {
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <ProfileShareModel
      shareSystemProps={{
        ...shareSystemProps,
        placeholder: rtl
          ? 'شارك العالم تطورات مشروعك / شركتك'
          : 'Share the World, the Progress of Your Project / Company',
        shareOptionsModelType: 'project',
        feedsSystemCategory: 'page',
      }}
    />
  )
}

export default ProjectProfileShare
